'use strict'

import game from './game'
import hilohitech from './hilohitech'

export default { game, hilohitech }



// WEBPACK FOOTER //
// ./resources/assets/js/hilohitech/api/index.js